import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const COOKIE_CONSENT_KEY = "cookie_consent_accepted";

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const hasAccepted = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!hasAccepted) {
      // Small delay for better UX - don't show immediately on page load
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-4xl mx-auto">
        <div className="bg-[#F1EDE4] border border-white/10 rounded-2xl shadow-2xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          {/* Icon */}
          <div className="hidden sm:flex w-12 h-12 rounded-xl bg-teal-500/20 items-center justify-center flex-shrink-0">
            <Cookie size={24} className="text-teal-400" />
          </div>
          
          {/* Text */}
          <div className="flex-1 text-sm sm:text-base text-gray-300 leading-relaxed">
            <span className="sm:hidden inline-flex items-center gap-2 mb-1">
              <Cookie size={18} className="text-teal-400" />
            </span>
            Мы используем cookies для улучшения работы сайта и анализа трафика. 
            Продолжая использовать сайт, вы соглашаетесь с{" "}
            <Link 
              to="/privacy-policy" 
              className="text-teal-400 hover:text-teal-300 underline underline-offset-2 transition-colors"
              data-testid="cookie-privacy-link"
            >
              Политикой конфиденциальности
            </Link>.
          </div>
          
          {/* Button */}
          <button
            onClick={handleAccept}
            className="paper-primary w-full sm:w-auto px-6 py-2.5 bg-teal-500 hover:bg-teal-400 text-white font-semibold rounded-xl transition-all duration-200 hover:shadow-lg hover:shadow-teal-500/25 flex-shrink-0"
            data-testid="cookie-accept-button"
          >
            Принять
          </button>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(100%);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slide-up {
          animation: slide-up 0.4s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default CookieConsent;
